import styled from 'styled-components';

export const ForaCasa = styled.main``;

export const ImagemBolas = styled.img`
  float: right;

  @media (max-width: 850px) {
    display: none;
  }
`;

export const ImagemBolasResp = styled.img`
  float: right;
  display: none;

  @media (max-width: 850px) {
    display: block;
  }

  @media (max-width: 480px) {
    width: 210px;
  }
`;

export const CimaCasa = styled.div`
  padding-top: 95px;
  width: 1379px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1550px) {
    width: 945px;
    padding-top: 40px;
  }

  @media (max-width: 1100px) {
    width: 755px;
  }

  @media (max-width: 850px) {
    width: 90%;
    flex-wrap: wrap;
    padding-top: 20px;
  }
`;

export const TextCasa1 = styled.h1`
  font-family: 'Rubik', sans-serif;
  font-size: 50px;
  font-weight: bold;
  color: #c73127;
  text-transform: uppercase;
  width: 427px;
  text-align: right;
  line-height: 48px;

  span {
    color: #b9b9b9;
  }

  @media (max-width: 1550px) {
    width: 410px;
    font-size: 44px;
  }

  @media (max-width: 1100px) {
    width: 301px;
    font-size: 33px;
    line-height: 35px;
  }

  @media (max-width: 850px) {
    display: none;
  }
`;

export const ForaTextCasa1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 850px) {
    width: 100%;
    padding-bottom: 20px;
    align-items: flex-start;
  }
`;

export const TextCasa1Resp = styled.h1`
  font-family: 'Rubik', sans-serif;
  font-size: 50px;
  font-weight: bold;
  /* color: #c73127; */
  color: ${({ theme }) => theme.color.primary};
  text-transform: uppercase;
  width: 184px;
  text-align: right;
  line-height: 48px;

  @media (max-width: 1550px) {
    width: 288px;
    font-size: 44px;
  }

  @media (max-width: 1100px) {
    width: 239px;
    font-size: 37px;
    line-height: 38px;
  }

  @media (max-width: 850px) {
    width: 100%;
    font-size: 50px;
    line-height: 48px;
    text-align: left;
  }

  @media (max-width: 480px) {
    font-size: 40px;
    line-height: 38px;
  }
`;

export const TextCasa2Resp = styled.h1`
  font-family: 'Rubik', sans-serif;
  font-size: 50px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.secondary};
  text-transform: uppercase;
  width: 242px;
  text-align: right;
  line-height: 48px;

  @media (max-width: 1550px) {
    width: 288px;
    font-size: 44px;
  }

  @media (max-width: 1100px) {
    width: 239px;
    font-size: 37px;
    line-height: 38px;
  }

  @media (max-width: 850px) {
    width: 322px;
    font-size: 50px;
    line-height: 48px;
    text-align: left;
  }

  @media (max-width: 480px) {
    font-size: 40px;
    line-height: 38px;
  }
`;

export const ImagemRiscoVermelho = styled.img`
  padding-left: 5%;
  padding-right: 5%;

  @media (max-width: 1550px) {
    height: auto;
  }

  @media (max-width: 850px) {
    padding-left: 0%;
    padding-right: 0%;
    display: none;
  }

  @media (max-width: 480px) {
    height: 270px;
  }
`;

export const ForaTextCasa2 = styled.div`
    margin-top: -35px;

    @media (max-width: 850px) {
      margin-bottom: 35px;
    } 
`;

export const TextCasa2 = styled.h3`
  font-size: 22px;
  font-weight: 300;
  color: #3d3d3d;
  width: 100%;
  margin-top: 35px;

  @media (max-width: 1100px) {
    font-size: 21px;
  }

  @media (max-width: 850px) {
    width: 100%;
  }

`;

export const ForaImgCasa1 = styled.div`
  margin: 0 auto;

  @media (max-width: 1550px) {
    width: 1050px;
  }

  @media (max-width: 1100px) {
    width: 800px;
  }

  @media (max-width: 850px) {
    display: none !important;
  }
`;

export const ForaImgCasa1Resp = styled.div`
  display: none !important;

  @media (max-width: 850px) {
    display: block !important;
  }
`;

export const ImagemCasa1 = styled.img`
  width: 1500px;
  margin: 0 auto;

  @media (max-width: 1520px) {
    width: 1100px;
  }

  @media (max-width: 1120px) {
    width: 800px;
  }

  @media (max-width: 850px) {
    width: 100%;
  }
`;

export const TextDiferenciais = styled.h3`
  font-family: 'Rubik', sans-serif;
  font-size: 40px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.primary};
  text-transform: uppercase;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 80px;

  @media (max-width: 1100px) {
    padding-top: 15px;
    padding-bottom: 60px;
  }

  @media (max-width: 480px) {
    font-size: 30px;
    padding-top: 0px;
    padding-bottom: 35px;
  }
`;
